import script from "./AppTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTitle.vue?vue&type=script&setup=true&lang=js"

import "./AppTitle.vue?vue&type=style&index=0&id=1bf888fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf888fa"]])

export default __exports__